import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import * as brandIcons from '@fortawesome/free-brands-svg-icons';

export const iconList: Array<solidIcons.IconDefinition> = [
    brandIcons.faEthereum,
    brandIcons.faInstagram,
    brandIcons.faTwitter,
    solidIcons.faInfoCircle,
    solidIcons.faLink,
    solidIcons.faCircle,
    solidIcons.faSpinner,
    solidIcons.faQuoteLeft,
    solidIcons.faQuoteRight,
    solidIcons.faEnvelope,
    solidIcons.faClock,
    solidIcons.faStopwatch,
    solidIcons.faCoins,
    solidIcons.faHandHoldingUsd,
    solidIcons.faChevronDown,
    solidIcons.faChevronUp,
    solidIcons.faChevronLeft,
    solidIcons.faChevronRight,
    solidIcons.faTimesCircle,
    solidIcons.faSadCry,
    solidIcons.faWallet
];